module.exports = __webpack_public_path__ + "00f30810abb30406b35392bf75f287a5.fbx";